var claseAlEntrar = function (elemento, clase, destino) {
    if (destino === void 0) { destino = document.body; }
    elemento.addEventListener('mouseover', function () { return destino.classList.add(clase); });
    elemento.addEventListener('mouseout', function () { return destino.classList.remove(clase); });
};
export default claseAlEntrar;
